import CT from '@marketplace-ai/tags';
import { Link } from 'react-router';
import { Button } from '~/components';
import { PROVIDER_AUTH_HOME } from '~/utils/constants';

interface Props {
  signedIn?: boolean;
}
export const NotFoundPage = ({ signedIn }: Props) => {
  return (
    <>
      <main className="grid min-h-full place-items-center bg-base px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <h1 data-cy={CT.notFound.title} className="mt-4 text-grey-100 heading-large-sb">
            Page not found
          </h1>
          <p className="mt-6 text-grey-400 heading-large">
            Sorry, we couldn’t find the page you’re looking for.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <Button
              cyTag={CT.notFound.goHome}
              onClick={() => (window.location.href = signedIn ? PROVIDER_AUTH_HOME : '/')}
            >
              Go back home
            </Button>
            {/* [MCV-1728] The Contact page, which shows the brand's info@ inbox. This page only
                renders signed out (UnauthenticatedFallback), so a same-tab router link is right. */}
            <Link
              data-cy={CT.notFound.contactSupport}
              to="/contact"
              className="text-sm font-semibold text-grey-100"
            >
              Contact support <span aria-hidden="true">&rarr;</span>
            </Link>
          </div>
        </div>
      </main>
    </>
  );
};
